/**
 * @generated SignedSource<<9f941ff862d2764358520de269768f5d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4Projects$data = {
  readonly jira: {
    readonly canCreateProject: boolean | null | undefined;
    readonly hasIsProjectsExpanded?: "JiraQuery";
    readonly shouldDisplay?: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4ProjectsForLanding">;
  readonly " $fragmentType": "Nav4Projects";
};
export type Nav4Projects$key = {
  readonly " $data"?: Nav4Projects$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4Projects">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "isProjectsExpanded"
    }
  ],
  "kind": "Fragment",
  "name": "Nav4Projects",
  "selections": [
    {
      "condition": "isProjectsExpanded",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "Nav4ProjectsForLanding"
        }
      ]
    },
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "condition": "isProjectsExpanded",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": "hasIsProjectsExpanded",
              "kind": "ScalarField",
              "name": "__typename"
            }
          ]
        },
        {
          "alias": "canCreateProject",
          "args": [
            (v0/*: any*/),
            {
              "kind": "Literal",
              "name": "type",
              "value": "CREATE_PROJECT"
            }
          ],
          "kind": "ScalarField",
          "name": "canPerform"
        },
        {
          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": "shouldDisplay",
              "args": [
                (v0/*: any*/),
                {
                  "kind": "Literal",
                  "name": "type",
                  "value": "VIEW_PROJECT_CREATION_ENTRY"
                }
              ],
              "kind": "ScalarField",
              "name": "canPerform"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "428884bcc8ab2cce6e9121035fe9e8b6";

export default node;
